import { ReactComponent as MessageIcon } from './messages.svg'
import styles from './NoMessages.module.scss'

const NoMessages = ({ children = 'Select a thread to start' }) => (
  <div className={styles.container}>
    <MessageIcon />
    <p>{children}</p>
  </div>
)

export default NoMessages
